import logger from './logger';

const STORAGE_KEY = 'savedOffers';

export const getSavedFavoritesFromStorage = () => {
  try {
    if (typeof localStorage === 'undefined') return [];
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (e) {
    logger.error('Error parsing saved favorites from localStorage:', e);
    return [];
  }
};

export const saveFavoritesToStorage = (favorites) => {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  } catch (e) {
    logger.error('Error saving favorites to localStorage:', e);
  }
};

export const addFavoriteToStorage = (offerId) => {
  try {
    const savedFavorites = getSavedFavoritesFromStorage();
    if (!savedFavorites.includes(offerId)) {
      savedFavorites.push(offerId);
      saveFavoritesToStorage(savedFavorites);
    }
    return savedFavorites;
  } catch (e) {
    logger.error('Error adding favorite to localStorage:', e);
    return [];
  }
};

export const removeFavoriteFromStorage = (offerId) => {
  try {
    const savedFavorites = getSavedFavoritesFromStorage();
    const updatedFavorites = savedFavorites.filter((id) => id !== offerId);
    saveFavoritesToStorage(updatedFavorites);
    return updatedFavorites;
  } catch (e) {
    logger.error('Error removing favorite from localStorage:', e);
    return [];
  }
};

export const clearFavoritesFromStorage = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    logger.error('Error clearing favorites from localStorage:', e);
  }
};
